import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { List } from 'semantic-ui-react';
import { userLanguage } from '../../../app/common/userLanguageSchema/userLanguage';
import { useStore } from '../../../app/stores/store';

function ClonedItemsModal() {
  const { clonedStore, activityStore, commonStore } = useStore();
  const { clonedItems, loadComponentById } = clonedStore;
  const history = useNavigate();
  const clonedroute = (a: any) => {
    history(`/mediaAssets/${a?.id}`);
    window.location.reload();
  };
  useEffect(() => {
    loadComponentById(activityStore.selectedActivity?.id);
    // eslint-disable-next-line
  }, []);
  return (
    <div style={{ padding: '10px' }}>
      <List divided relaxed style={{ padding: '10px', cursor: 'pointer' }}>
        {clonedItems.length > 0 ? (
          clonedItems.map((a: any) => (
            <>
              <List.Item style={{ padding: '7px' }}>
                <List.Content onClick={() => clonedroute(a)}>
                  <List.Header as="a">{a.title}</List.Header>
                </List.Content>
              </List.Item>
            </>
          ))
        ) : (
          <p
            style={{
              marginTop: '20%',
              padding: 'auto',
              color: 'black',
              textAlign: 'center',
            }}
            //No Cloned Assets Found
          >
            {
              (
                userLanguage[0]
                  .AssetsViewItemLevelViewPageAssetsSegmentClonedItemsTab
                  ?.AVILVPASCITPL01 as any
              )?.[`${commonStore.language.key}`]
            }
          </p>
        )}
      </List>
    </div>
  );
}

export default observer(ClonedItemsModal);
